/** Enregistrement des éléments de mise en forme */
import "./tabs";
import "./rows";
import "./columns";
import "./panels";
import "../basic/header";
import "../basic/etc-field";
import "../basic/etc-widget";
